export default __webpack_public_path__ + "4c6b94fd1d07f8beff7cf3364d4d4555.woff";